import { analyticsTracker } from "../shared/tracking/analyticsTracker";
import { useMutation, useQuery } from "@tanstack/react-query";
import {
  getAllMyFavorites,
  toggleMarkFavoriteProperty,
} from "../api/favorites/favoritesApi";

type setIsFavoriteChangedFuncType = (
  isFavoriteChanged: boolean | ((prev: boolean) => boolean),
) => void;

export const useToggleMarkFavoriteProperty = (
  setIsFavoriteChanged: setIsFavoriteChangedFuncType,
) => {
  return useMutation({
    mutationFn: toggleMarkFavoriteProperty,
    onSuccess: (data: { action?: string } | undefined, propertyId: number) => {
      setIsFavoriteChanged((prev: boolean) => !prev);
      if (data?.action === "added" || data?.action === "removed") {
        analyticsTracker.trackOnPage(data.action === "added" ? "favorite_add" : "favorite_remove", propertyId);
      }
    },
  });
};

export const useGetAllMyFavoriteProperties = () => {
  return useQuery({
    queryKey: ["favorites"],
    queryFn: getAllMyFavorites,
  });
};
